import { BREAKPOINTS } from '../config';

import { updateStickyStack } from '../layout/sticky';

function syncLogosWrapperSize() {
  const industries = document.querySelector('.industries');

  if (!industries) return;

  const wrapper = industries.querySelector('.logos-wraapp');
  const logos = industries.querySelector('.industries__logos');

  if (!wrapper || !logos) return;

  function update() {
    if (window.innerWidth <= BREAKPOINTS.mqTouch) {
      const { height } = logos.getBoundingClientRect();

      wrapper.style.height = `${height}px`;
    } else {
      wrapper.style.height = '';
    }

    requestAnimationFrame(updateStickyStack);
  }

  update();
  window.addEventListener('resize', update);
}

window.addEventListener('load', syncLogosWrapperSize);
